<template>
  <div class="q-pa-md wallet-table">
    <q-table
      :title="tableTitle"
      :rows="albums"
      :columns="getColumns"
      row-key="name"
      class="q-mb-md"
    >
      <template v-slot:body="props">
        <q-tr :props="props">
          <q-td :key="firstColumnKey" :props="props">
            <a
              v-if="shouldShowLink(props.row)"
              :href="props.row.commission.url"
            >
              <span v-html="props.row.commission.commission_id"></span>
            </a>
            <span v-else v-html="props.row.commission.commission_id"></span>
          </q-td>

          <q-td
            v-if="shouldShowSecondColumn"
            :key="secondColumnKey"
            :props="props"
          >
            <span v-if="booking">
              {{ $t('userPanel.wallet.bookingReference') }}
              {{ props.row.commission.run_title }}
            </span>
            <span v-else v-html="props.row.commission.run_title"></span>
          </q-td>

          <q-td key="commission" :props="props">
            {{
              formatCommission(
                props.row.commission_value,
                props.row.commission_original_currency
              )
            }}
          </q-td>

          <q-td key="date" :props="props">
            {{ props.row.date }}
          </q-td>

          <q-td
            v-if="shouldShowPaidoutDate"
            key="commission_paidout_date"
            :props="props"
          >
            {{ props.row.commission_paidout_date || '-' }}
          </q-td>
        </q-tr>
      </template>
    </q-table>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'WalletAlbumsTable',
  props: {
    albums: {
      required: false,
      default: () => [],
      type: Array,
    },
    booking: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
    isAgent() {
      return this.user.role === 'agent';
    },
    isOrganizer() {
      return this.user.role === 'organizer';
    },
    tableTitle() {
      return this.booking
        ? this.$t('userPanel.wallet.bookingTableTitle')
        : this.$t('userPanel.tableTitle');
    },
    firstColumnKey() {
      if (this.booking) return 'bookingId';
      return this.isAgent ? 'transaction' : 'albumLink';
    },
    secondColumnKey() {
      return this.booking ? 'bookingTitle' : 'gear';
    },
    shouldShowSecondColumn() {
      return !this.isAgent;
    },
    shouldShowPaidoutDate() {
      return !(this.booking && this.isOrganizer);
    },
    getColumns() {
      const columns = [];

      columns.push({
        name: this.firstColumnKey,
        label: this.getFirstColumnLabel(),
        field: 'commission.commission_id',
        align: 'left',
        sortable: false,
        classes: 'bg-grey-2 ellipsis',
        headerClasses: 'bg-primary text-white',
      });

      if (this.shouldShowSecondColumn) {
        columns.push({
          name: this.secondColumnKey,
          label: this.getSecondColumnLabel(),
          field: 'commission.run_title',
          align: 'left',
          sortable: false,
        });
      }

      columns.push({
        name: 'commission',
        align: 'center',
        label: this.getCommissionLabel(),
        field: 'commission_value',
        sortable: false,
      });

      columns.push({
        name: 'date',
        label: this.$t('userPanel.tableColumns.date'),
        format: (val) => `${this.formateDate(val)}`,
        align: 'left',
        field: 'date',
        sortable: false,
      });

      if (this.shouldShowPaidoutDate) {
        columns.push({
          name: 'commission_paidout_date',
          label: this.$t('userPanel.tableColumns.commissionData'),
          align: 'left',
          field: 'commission_paidout_date',
        });
      }

      return columns;
    },
  },
  methods: {
    getFirstColumnLabel() {
      if (this.booking) {
        return this.$t('userPanel.wallet.tableColumns.bookingId');
      }
      return this.isAgent
        ? this.$t('dashboard.ordersTable.orderId')
        : this.$t('dashboard.ordersTable.albumLink');
    },
    getSecondColumnLabel() {
      return this.booking
        ? this.$t('userPanel.wallet.tableColumns.bookingTitle')
        : this.$t('userPanel.tableColumns.gear');
    },
    shouldShowLink(row) {
      return !this.booking && !this.isAgent && row.commission.url;
    },
    formatCommission(value, currency) {
      return `${Math.floor(Number(value) * 100) / 100}${currency}`;
    },
    showImages(img, album) {
      this.$emit('showImageModal', { images: img, album_name: album });
    },
    getCommissionLabel() {
      return this.booking
        ? this.$t('userPanel.wallet.tableColumns.bookingPrice')
        : this.$t('userPanel.tableColumns.commission');
    },
  },
};
</script>

<style lang="scss" scoped>
.wallet-table {
  margin-bottom: 1rem;

  .q-table {
    margin-bottom: 1rem;
  }
}
</style>
